export const URL_GET_SRCS = '/track/sources/'
export const URL_GET_INIT_TIME_ZS = '/track/init_time_z_all/'
export const URL_GET_TRACK_DATA = '/track/data/'
export const URL_GET_WIND_FILE = '/wind/'
export const URL_GET_TYPHOON_PROBABILITY = '/track/probability/'
export const URL_GET_SATELLITE_IMAGE_INFO = '/satellite/'
export const URL_GET_SATELLITE_LATEST_TIME =  '/satellite/visible/latest_time/'


// WEBPACK FOOTER //
// ./src/store/urls.js